@defer (on viewport; when news$ !== undefined) {
  @if (isBrowser && (!hideOnZeroResults || (news$ | async)?.length > 0)) {
    <div class="carousel__wrapper">
      <h2 class="carousel__title" [attr.data-translate]="'title.news'">{{ title }}</h2>
      @if (!isMovieStieConfig() && newsSubtitle) {
        <p class="carousel__description" [attr.data-translate]="'public.commons.news.subtitle'">
          {{ newsSubtitle }}
        </p>
      }
      @if (!isMovieStieConfig() && viewAllLink && !hideViewAll) {
        <a class="carousel__view-all hyperlink" i18n="View all button@@button.view-all" [routerLink]="viewAllLink"
          >View all</a
        >
      }
      @if (!isMovieStieConfig()) {
        <button
          pButton
          [id]="arrowLeftCssSelector"
          class="carousel__arrow carousel__left-arrow"
          aria-label="Previous new"
        >
          <ush-arrow [template]="arrowTemplate" orientation="left"></ush-arrow>
        </button>
        <button
          pButton
          [id]="arrowRightCssSelector"
          class="carousel__arrow carousel__right-arrow"
          aria-label="Next new"
        >
          <ush-arrow [template]="arrowTemplate" orientation="right"></ush-arrow>
        </button>
      }

      <div class="carousel__content">
        @if (items && items.length) {
          <ng-template [ngTemplateOutlet]="newsCarousel" [ngTemplateOutletContext]="{ $implicit: items }" />
        } @else {
          @if (news$ | async; as _newItems) {
            <ng-template [ngTemplateOutlet]="newsCarousel" [ngTemplateOutletContext]="{ $implicit: _newItems }" />
          } @else {
            <div class="skeleton-news-wrapper">
              <p-skeleton *ngFor="let _ of Array(5); let i = index"></p-skeleton>
            </div>
          }
        }
      </div>
    </div>
  } @else {
    <div class="carousel__wrapper"></div>
  }
} @placeholder {
  <div style="height: 400px; width: 100%; background: transparent"></div>
}

<ng-template #newsCarousel let-newItems>
  <swiper-container
    #swiper
    ushSwiperElement
    [config]="isMovieStieConfig() ? movieSiteSwiperConfig : swiperConfig"
    init="false"
  >
    <swiper-slide *ngFor="let newsItem of newItems" lazy="true">
      <community-elements-ui-news-card [news]="newsItem"></community-elements-ui-news-card>
    </swiper-slide>
  </swiper-container>
</ng-template>
